module.exports = __webpack_public_path__ + "static/img/dev1.09589b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/development/dev1.jpg
// module id = qYOZ
// module chunks = 0